import styled from 'styled-components';

import { Icon } from 'coreOld/elements';

const Wrapper = styled.div`
  position: absolute;
  bottom: 22px;
  left: -10px;
  font-size: 12px;

  svg {
    color: ${({ theme }) => theme.palette.neutral.darkest} !important;
  }
`;

const DetailsIcon = () => {
  return (
    <Wrapper>
      <Icon name={Icon.INFO} hover />
    </Wrapper>
  );
};

export default DetailsIcon;
